import styled from 'styled-components';

export const MainWrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
  .ant-table-content .ant-table-tbody {
    .ant-table-expanded-row td > div {
      padding: 0;
    }
    .ant-table-row td > div {
      padding: 9px 12px;
    }
  }
`;
